import React from "react";
import { WizardStep } from "../machines/immersive-wizard.machine";
import { BaseDemoProps } from "../types/wizard.types";
import WebDemo from "./web/WebDemo";
import StaffAppDemo from "./mobile/StaffAppDemo";
import MemberAppDemo from "./mobile/MemberAppDemo";
import PointOfSalesDemo from "./mobile/PointOfSalesDemo";

const DemoContainer: React.FC<BaseDemoProps> = ({ currentState, formData }) => {
  const browserDemoSteps = [
    WizardStep.Subdomain,
    WizardStep.Color,
    WizardStep.Logo,
    WizardStep.Schedule,
    WizardStep.ClassSchedule,
    WizardStep.AppointmentTypes,
    WizardStep.AppointmentPackages,
    WizardStep.MembershipPlans,
    WizardStep.RankTrackingApp,
    WizardStep.CommittedClubApp,
  ];

  if (browserDemoSteps.includes(currentState as any)) {
    return <WebDemo formData={formData} currentStep={currentState} />;
  }

  switch (currentState) {
    case WizardStep.PointOfSales:
      return <PointOfSalesDemo formData={formData} />;
    case WizardStep.StaffApp:
      return <StaffAppDemo formData={formData} />;
    case WizardStep.MemberApp:
      return <MemberAppDemo formData={formData} />;
    default:
      return (
        <div className="tw-w-full tw-h-full tw-bg-gray-100 tw-rounded-lg tw-flex tw-items-center tw-justify-center">
          <div className="tw-text-center tw-text-gray-600">
            <h3 className="tw-text-xl tw-font-semibold tw-mb-2">
              Demo Preview
            </h3>
            <p>Step: {currentState}</p>
          </div>
        </div>
      );
  }
};

export default DemoContainer;
